import { makeHoc } from '@udemy/shared-utils';
import { useFeatures } from './use-features';
/**
 * Higher order component that provides access to experiments from `ExperimentationProvider`. Uses
 * the `useFeatures` hook internally.
 *
 * @example
 * ```tsx
 * interface MyComponentProps extends WithFeaturesProps {
 * }
 *
 * class _MyComponent extends React.Component<MyComponentProps> {
 *   render() {
 *     const {isLoading, featureVariantAssignments} = this.props.experimentationResult
 *     return (
 *      <div>
 *       <p>Some Feature Configuration: {JSON.stringify(featureVariantAssignments.get('some_feature').configuration}</p>
 *     </div>
 *     );
 *   }
 * };
 *
 * export const MyComponent = withFeatures(['some_feature'], _MyComponent);
 * ```
 */

export function withFeatures(features, Component) {
  const hoc = makeHoc({
    useGetData: () => {
      const {
        isLoading,
        featureVariantAssignments
      } = useFeatures(features);
      return {
        experimentationResult: {
          isLoading,
          featureVariantAssignments
        }
      };
    },
    getDisplayName: name => `WithFeatures(${name})`,
    getPropTypes: propTypes => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const {
        experimentationResult,
        ...propTypesWithoutStores
      } = propTypes;
      return propTypesWithoutStores;
    }
  });
  return hoc(Component);
}
//# sourceMappingURL=with-features.js.map